import { PolicyId } from '../types';

export const queryKeys = {
  base: ['policies'] as const,
  list: () => [...queryKeys.base] as const,
  detail: (id: PolicyId) => [...queryKeys.base, id] as const,
};
